<section [ngClass]="(isSticky === true && !isMobileView) ? 'sticky' : 'hide-header'"
  [ngStyle]="{'top':baseSiteId=='vax'?'126px':'112px'}">
  <div class="d-flex justify-content-center">
    <div class="scheduler sticky-scheduler">
      <div *ngIf="schedulerStatus=='All units and doses have been scheduled'">
        <img src="/icons/confirmation-positive-green.png" alt="confirm" />
      </div>
      <div
        [ngClass]="{'unit-scheduled':schedulerStatus=='All units and doses have been scheduled','sticky-fontstyle':baseSiteId=='vax'}">
        {{schedulerStatus}}
      </div>
      <div class="units-doses mt-2"
        *ngIf="(schedulerStatus=='Remaining to schedule' || schedulerStatus=='Exceeds Total')">
        <div>
          <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{totalFutureUnits}}</div>
          <div>units</div>
        </div>
        <span>|</span>
        <div>
          <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{totalFutureDoses}}</div>
          <div>Doses</div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center plpbutton-header ml-2" id="actionButton">
      <button type="button" class="btn-secondary mr-2" (click)="navigateCart()">
        Edit doses
      </button>
      <button type="button" class="btn-primary" [disabled]="!isUnitSelected"
        (click)="onContinue(confirmModal,deliveryDateModal)">
        Continue
      </button>
    </div>
  </div>
</section>
<section *ngIf="isCartSticky" class="scheduler-section cart-section"
  [ngClass]="(isCartSticky === true && !isMobileView) ? 'cart-sticky' : 'cart-hide-header'">
  <div class="d-flex cart">
    <div *ngFor="let item of futureshipProdLists">
      <div class="row product product-sticky" (click)="openProductDetails(item)">
        <div [innerHtml]="item.product.baseProductName"></div>
        <div [innerHtml]="item.product.description"></div>
        <div class="w-100 text-center"
          [ngClass]="{'remaining-style':item.cartStatus=='Remaining to schedule','exceeds-style':item.cartStatus=='Exceeds','scheduled':item.cartStatus=='Scheduled'}">
          {{item.cartStatus}}</div>
        <div class="d-flex"
          [ngClass]="{'remaining-style':item.cartStatus=='Remaining to schedule','exceeds-style':item.cartStatus=='Exceeds','scheduled':item.cartStatus=='Scheduled'}">
          <span [ngClass]="{'exceeds-style':item.cartStatus=='Exceeds','scheduled':item.cartStatus=='Scheduled'}">{{
            item.quantity }} Units</span>
          <span class="ml-1 mr-1">|</span>
          <div
            [ngClass]="{'remaining-style':item.cartStatus=='Remaining to schedule','exceeds-style':item.cartStatus=='Exceeds','scheduled':item.cartStatus=='Scheduled'}">
            {{ item.quantity*item.product.quantityPerUnit }} Doses</div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="row float-right">
  <div class="bc-Dash-Div">
    <a (click)="navigateCart()">
      <img [src]="'/icons/'+baseSiteId+'/chevron-left_green.svg'" class="svg-Images" alt="left" />
      Back to Cart</a>&nbsp;&nbsp;
    <a class="excel-download mr-1" (click)="exportExcel()"><img class="mr-1"
        [src]="'/icons/'+baseSiteId+'/excel_new.png'" alt="XLS" />
      <span>XLS</span></a>&nbsp;&nbsp;
    <a class="print mr-3" onclick="window.print()" href="javascript:void(0)">
      <img [src]="'/icons/'+baseSiteId+'/print.svg'" class="svg-Images" alt="print" />
      Print</a>
  </div>
</section>
<section class="d-flex scheduler-section">
  <div class="col-md-5 scheduler-content" [innerHTML]="schedulerContent"></div>
  <div class="col-md-3">
    <div class="scheduler">
      <div *ngIf="schedulerStatus=='All units and doses have been scheduled'">
        <img src="/icons/confirmation-positive-green.png" alt="confirm" />
      </div>
      <div [ngClass]="{'unit-scheduled':schedulerStatus=='All units and doses have been scheduled'}">{{schedulerStatus}}
      </div>
      <div class="units-doses mt-2"
        *ngIf="(schedulerStatus=='Remaining to schedule' || schedulerStatus=='Exceeds Total')">
        <div>
          <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{totalFutureUnits}}</div>
          <div>units</div>
        </div>
        <span>|</span>
        <div>
          <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{totalFutureDoses}}</div>
          <div>Doses</div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4" id="actionButton">
    <section class="plpbutton">
      <button type="button" class="btn-primary" [disabled]="!isUnitSelected"
        (click)="onContinue(confirmModal,deliveryDateModal)">
        Continue</button><br />
      <button type="button" class="btn-secondary mt-2" (click)="navigateCart()">
        Edit doses
      </button>
    </section>
  </div>
</section>
<section class="scheduler-section cart-section">
  <div>
    <p>
      <img class="mr-1" [src]="'/icons/'+baseSiteId+'/cart.png'" alt="" />Products in
      your cart
    </p>
  </div>
  <div class="d-flex cart">
    <div *ngFor="let item of futureshipProdLists">
      <div class="product" (click)="openProductDetails(item)">
        <div class="mb-4" [innerHtml]="item.product.baseProductName"></div>
        <div [innerHtml]="item.product.description"></div>
        <div
          [ngClass]="{'exceeds-style':item.cartStatus=='Exceeds','remaining-style':item.cartStatus=='Remaining to schedule','scheduled':item.cartStatus=='Scheduled'}">
          {{item.cartStatus}}</div>
        <div class="d-flex"
          [ngClass]="{'remaining-style':item.cartStatus=='Remaining to schedule','exceeds-style':item.cartStatus=='Exceeds','scheduled':item.cartStatus=='Scheduled'}">
          <div
            [ngClass]="{'remaining-style':item.cartStatus=='Remaining to schedule','exceeds-style':item.cartStatus=='Exceeds','scheduled':item.cartStatus=='Scheduled'}">
            {{ item.quantity }} Units</div>
          <span class="ml-1 mr-1">|</span>
          <div
            [ngClass]="{'remaining-style':item.cartStatus=='Remaining to schedule','exceeds-style':item.cartStatus=='Exceeds','scheduled':item.cartStatus=='Scheduled'}">
            {{ item.quantity*item.product.quantityPerUnit }} Doses</div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Ship Immediately-->
<section class="scheduler-section ship-immediate">
  <div class="row align-items-center">
    <div class="ml-3">
      <img class="mr-1" [src]="'/icons/'+baseSiteId+'/timeArrow2.png'" alt="" /><span>Ship
        immediately</span>
    </div>
    <div class="col-md-5 d-flex align-items-center">
      <div class="request-date">Requested deliver date</div>
      <div>
        <label class="searchbox orders-filter time-frame d-flex">
          <img [src]="'/icons/'+baseSiteId+'/calendar.svg'" alt="" />
          <input readonly type="text" class="input-filter" [(ngModel)]="deliveryDate" [ngbPopover]="popSaveContent"
            placement="bottom" #s3="ngbPopover" triggers="manual" popoverClass="savedordermini-popover"
            (click)="openCalendar(s3)" /></label>
      </div>
      <ng-template #popSaveContent>
        <bs-datepicker-inline [bsConfig]="{
            containerClass: 'order-list-date',
            dateInputFormat: 'MM/DD/YYYY',autoclose: 'true'
          }" (bsValueChange)="onValueChange($event,s3)" [minDate]="minDate" [maxDate]="maxDate"
          [datesDisabled]="disabledDates"></bs-datepicker-inline>
        <hr />
        <div class="d-flex mt-4 delivery-hours-title">
          <div class="col-10">Delivery hours</div>
          <div class="col-2 mr-3" (click)="onShowOrHideHours(s3)">
            <img class="plus-icon" src="/icons/plus-green.png" *ngIf="!isShowDeliveryHours" />
            <img class="minus-icon" src="/icons/minus-green.png" *ngIf="isShowDeliveryHours" />
          </div>
        </div>
        <hr class="hr-style" />
        <section *ngIf="isShowDeliveryHours" class="delivery-hours">
          <div class="mb-2">
            <a class="surchargeLabel" (click)="navigateProfile()">Edit hours</a>
          </div>
          <div class="row hours-row mb-1" *ngFor="let hour of deliveryHours">
            <div class="col-md-5 day-style">{{hour.day}}</div>
            <div class="mr-5 time-style">{{hour.fromTime}}</div>
            <div class="time-style">{{hour.toTime}}</div>
          </div>
        </section>
        <div class="mt-3 text-center">
          <button type="button" class="btn-primary col-11" (click)="updateDeliveryDate(true,s3)">
            Save</button>
        </div>
        <div class="mt-2 text-center mb-3">
          <button type="button" class="btn-secondary col-11" (click)="closePopup(s3)">
            Cancel
          </button>
        </div>
      </ng-template>
    </div>
    <div class="text-right shipimmediate-total col">
      <span class="mr-2 tot-unit-style">Total Units</span>
      <span id="shipImmediateUnit">{{ "0" }}</span><span class="ml-1 mr-2">Units</span>
      <span class="mr-2">|</span>
      <span class="mr-2" id="shipImmediateDoses">{{ "0" }}</span><span class="ml-1 mr-4">Doses</span>
      <span (click)="showUnits = !showUnits" class="ml-5">
        <!-- <img src="/icons/plus-green.png" *ngIf="showUnits == false" />
        <img src="/icons/minus-green.png" *ngIf="showUnits == true" /> -->
        <span class="accMinusIcon fa-minus acc-plus-icon fa plusMinusIcon" *ngIf="showUnits==true">
        </span>
        <span class="accPlusIcon fa-plus acc-plus-icon fa plusMinusIcon" *ngIf="showUnits==false">
        </span>
      </span>
    </div>
  </div>
  <div *ngIf="showUnits" [ngClass]="{'scroll-behaviour':isMobileView}">
    <div class="d-flex">
      <div class="row mt-4" *ngFor="let item of futureshipProdLists;let i=index">
        <div class="unit-card">
          <span>Units</span>
          <input type="number" class="prod-quantity text-center"
            (keyup)="performQuantityComputation('shipImmediate',item.product.code,item.product.quantityPerUnit)"
            id="{{ 'shipImmediate'+item.product.code }}" maxlength="4" [value]="0" max="9999" min="1"
            (focusout)="onFocusout('shipImmediate',item.product.code)" [disabled]="item.shipNow===false"
            (keydown)="validateInput($event)" appNoMouseScroll />
          <div id="{{ 'shipImmediatedoses'+item.product.code }}"></div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Calendar by week-->
<section>
  <div class="scheduler-section week-section" *ngFor="let item of weekList;let i=index">
    <div class="row align-items-center ">
      <div class="ml-3" [ngStyle]="{'margin-right':'-40px'}">
        <img class="mr-1" [src]="'/icons/'+baseSiteId+'/calendar.svg'" alt="" /><span>{{ item.month+'
          '+item.year }}</span>
      </div>
      <div class="col-md-3" [ngClass]="{'week-select-view':isMobileView}">
        <ng-select id="{{item.month+item.year}}" (change)="onChangeWeek($event,item)" [items]="item.weeks"
          [multiple]="false" bindLabel="name" bindValue="value" placeholder="select week" [(ngModel)]="weekObj[i]">
        </ng-select>
      </div>
      <div class="col d-flex align-items-center justify-content-end ml-4" [ngClass]="{'week-total-view':isMobileView}">
        <span class="tot-unit-style">Total Units</span>
        <span class="ml-2 mr-2" id="{{item.month+item.year+'Unit'}}">{{ "0" }}</span><span> Units</span>
        <span class="mr-2 ml-2">|</span>
        <span class="mr-2" id="{{item.month+item.year+'Doses'}}">{{ "0" }}</span><span>Doses</span>
        <span (click)="showOrHideUnit(i)" class="week-total-align">
          <span class="accMinusIcon fa-minus acc-plus-icon fa plusMinusIcon plusMinusIcon-align"
            *ngIf="item.showUnit==true">
          </span>
          <span class="accPlusIcon fa-plus acc-plus-icon fa plusMinusIcon plusMinusIcon-align"
            *ngIf="item.showUnit==false">
          </span>
        </span>
      </div>
    </div>
    <div *ngIf="item.showUnit==true">
      <div class="d-flex" [ngClass]="{'scroll-behaviour':isMobileView}">
        <div class="row mt-4" *ngFor="let element of futureshipProdLists">
          <div class="unit-card">
            <span>Units</span>
            <input type="number" class="prod-quantity text-center" value="0"
              (keyup)="performQuantityComputation(item.month+item.year,element.product.code,element.product.quantityPerUnit,item)"
              id="{{item.month+item.year+element.product.code}}" maxlength="4" (keydown)="validateInput($event)" min="0"
              max="9999" (focusout)="onFocusout(item.month+item.year,element.product.code)" appNoMouseScroll />
            <div class="week-doses" id="{{item.month+item.year+element.product.code+'doses'}}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
<ng-template #deliveryDateModal let-modal>
  <div class="modal-header header-style justify-content-center">
    <div class="mt-2">
      Request Delivery Date
    </div>
  </div>
  <div class="modal-body delivery-body-style">
    <div>The following products are not eliglible for the future ship promotion:
    </div>
    <div *ngFor="let cart of productList">
      <div class="row mt-2">
        <div class="col-md-6 location-style d-flex">
          <div class="d-flex mt-2">
            <img [src]="'/icons/'+baseSiteId+'/location.svg'" alt="location" />
            <span class="mt- ml-1">{{ shipLocation }}({{shipLocationId}})</span>
          </div>
        </div>
        <div class="col-md-6">
          <section class="d-flex">
            <div class="delivery-date">Requested delivery date</div>
            <div>
              <label class="searchbox orders-filter time-frame d-flex">
                <img [src]="'/icons/'+baseSiteId+'/calendar.svg'" alt="" />
                <input readonly type="text" class="delivery-input-filter"
                  [ngModel]="setProductDeliveryDate(cart.cartType)" [ngbPopover]="popSaveContent" placement="bottom"
                  #s3="ngbPopover" triggers="manual" popoverClass="savedordermini-popover" (click)="openCalendar(s3)" />
              </label>
              <ng-template #popSaveContent>
                <bs-datepicker-inline [bsConfig]="{
                      containerClass: 'order-list-date',
                      dateInputFormat: 'MM/DD/YYYY',autoclose: 'true'
                    }" (bsValueChange)="onValueChange($event,s3)" [minDate]="cart.minDate" [maxDate]="cart.maxDate"
                  [datesDisabled]="cart.disabledDates"></bs-datepicker-inline>
                <hr />
                <div class="d-flex mt-4 delivery-hours-title">
                  <div class="col-10">Delivery hours</div>
                  <div class="col-2 mr-3" (click)="onShowOrHideHours(s3)">
                    <img class="plus-icon" src="/icons/plus-green.png" *ngIf="!isShowDeliveryHours" />
                    <img class="minus-icon" src="/icons/minus-green.png"
                      *ngIf="isShowDeliveryHours" />
                  </div>
                </div>
                <hr class="hr-style" />
                <section *ngIf="isShowDeliveryHours" class="delivery-hours">
                  <div class="mb-2">
                    <a class="surchargeLabel" (click)="navigateProfile()">Edit hours</a>
                  </div>
                  <div class="row hours-row mb-1" *ngFor="let hour of deliveryHours">
                    <div class="col-md-5 day-style">{{hour.day}}</div>
                    <div class="time-style mr-5">{{hour.fromTime}}</div>
                    <div class="time-style">{{hour.toTime}}</div>
                  </div>
                </section>
                <div class="mt-3 text-center">
                  <button type="button" class="btn-primary col-11"
                    (click)="updateDeliveryDate(cart.cartType=='STANDARD'?false:'flu',s3)">
                    Save</button>
                </div>
                <div class="mt-2 text-center mb-3">
                  <button type="button" class="btn-secondary col-11" (click)="closePopup(s3)">
                    Cancel
                  </button>
                </div>
              </ng-template>
            </div>
          </section>
          <section>
            <div class="alert-msg">The requested date is not a guarantee and may change based on product availability
              and
              unforseen delays.
            </div>
          </section>
        </div>
      </div>
      <hr>
      <div class="row list-item" *ngFor="let item of cart.entries" [ngStyle]="{'margin-bottom':'50px'}">
        <div class="col-md-2">
          <img class="image-align" [src]="getImage(item?.product)">
        </div>
        <div class="col-md-5 item-style text-left">
          <div [innerHTML]="item.product.baseProductName"></div>
          <div [innerHTML]="item.product.description"></div>
          <div class="mt-1">{{item.product.variantOptions[0].description}}</div>
          <div class="mt-1"><span class="mr-1">{{item.product.code}}</span><span>|</span><span
              class="ml-1">{{item.product.manufacturer}}</span></div>
          <div *ngIf="item?.product?.conditions == 1
            ? item?.product?.conditions
            : item?.product?.conditions as contractGroups">
            <div class="mt-1" *ngIf="item.product?.conditions as contractGroups">
              <div>Contract Group</div>
              @let product = item?.product;
              <ng-select *ngIf="contractGroups.length > 1; else singleContract" [items]="contractGroups"
                [searchable]="false" [clearable]="false" bindLabel="contractDesc" bindValue="contractId"
                placeholder="Select Contract Group" class="mt-1 dropdown-contractGroup" (change)="onChange($event,item)"
                [(ngModel)]="product.selectedContract">
              </ng-select>
              <ng-template #singleContract>
                <span [ngStyle]="{
                  'font-size.px': '14',
                  color: '#313131',
                  'text-transform': 'uppercase'
                }">
                  {{ contractGroups[0].contractDesc }}
                </span>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="col-md-2 text-left">
          <div class="mb-1">Your price</div>
          <ng-container *ngIf="item?.product?.conditions && !item?.product?.hidePriceForProduct; else priceBlock">
            <div *ngIf="item?.product?.conditions.length > 1 else conditionEqualToOne">
              <div id="{{'price'+item?.product?.code}}"> {{getContractPrice(item)}}</div>
            </div><br />
            <ng-template #conditionEqualToOne>
              <span>{{item?.product?.conditions[0]?.contractPrice?.value |
                currency }}
              </span>
            </ng-template>
          </ng-container>
          <ng-template #priceBlock>
            <span class="price-style">{{item?.product?.hidePriceForProduct ? "$--" : item?.product?.price?.value | currency}}
            </span>
          </ng-template>
          <span *ngIf="item?.sim_excise_tax.value > 0.00 && !item?.product?.hidePriceForProduct">
            <span>{{item?.sim_excise_tax?.value | currency}}/</span>
            <span>{{item?.product?.unit}}</span>
            <span>Federal Excise</span>
            <span>Tax will be</span>
            <span>added</span>
          </span>
        </div>
        <div class="col-md-3 units text-center">
          <span class="unit-style">{{'Units'}}</span>
          <section class="unit-area">
            <input type="number" class="prod-quantity text-center" [value]="item.quantity" disabled />
            <div>{{(item?.quantity*item?.product?.quantityPerUnit)+' Doses'}}</div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer footer-style">
    <section class="col-md-12 d-flex flex-column">
      <button type="button" class="btn-primary" (click)="onDeliveryDateSubmit()">
        Submit and continue</button>
      <button type="button" class="btn-secondary mt-2" (click)="closeModal()">
        Back to future shipments
      </button>
    </section>
  </div>
</ng-template>
<ng-template #confirmModal let-modal>
  <div class="modal-header header-style justify-content-center">
    <div class="mt-2">
      Confirm Requested Doses
    </div>
  </div>
  <div class="modal-body body-multiloc-style">
    <div>The number of doses scheduled differs from your original selections. Is this your preference?
    </div>
  </div>
  <div class="modal-footer footer-style justify-content-center">
    <section class="plpbutton btn-style col-md-12">
      <button type="button" class="btn-primary ml-3" (click)="onConfirmContinue(deliveryDateModal)">
        Yes, continue</button>
      <button type="button" class="btn-secondary ml-1" (click)="closeModal()">
        No, edit schedule
      </button>
    </section>
  </div>
</ng-template>
<ng-template #productDetailModal let-modal>
  <div class="modal-header relative">
    <h4 class="modal-title-top20">Product Details</h4>
    <div class="cls-btn">
      <img [src]="'/icons/'+baseSiteId+'/close.svg'" (click)="close()" alt="">
    </div>
  </div>
  <div class="modal-body miniCart-popover">
    <div class="row row-20 product-details pb-3" id="leftCont-rightNav">
      <section class="row row-20">
        <section class="container-pdp">
          <aside aria-label="Product Details" id="prodImg" class="col-xs-12 col-sm-4 col-md-4 float-right">
            <a (click)="openImage(content)">
              <img class="modal-image-align" [src]="getImage(selectedProduct?.product)">
            </a>
            <span class="fullscreen-image selected align-bottom" data-toggle="modal" data-target="#pdp-image-zoom">
              <a (click)="openImage(content)" title="fullscreen link"><img class="expandable"
                  [src]="'/icons/'+baseSiteId+'/fullscreen.svg'" alt="" /></a>
            </span>
            <a>
              <div *ngFor="let carousel of gallery">
                <div class="xzoom-thumbs leftFloat">
                  <a class="item">
                    <cx-media class="cx-product-image carousel-zoom" [container]="carousel?.product" format="product"
                      [alt]="img">
                    </cx-media>
                  </a>
                </div>
              </div>
            </a>
            <br /><br />
            <ng-template #content let-modal>
              <ngb-carousel *ngIf="
              selectedProduct?.product?.images != undefined ||
              selectedProduct?.product?.images?.length > 0
                "
                ngClass="selectedProduct?.product?.images?.GALLERY.length > 0 ? 'carousel-nopagination' : 'carousel-pagination' ">
                <ng-template ngbSlide *ngFor="let carousel of gallery">
                  <div class="headerstrip">
                    <div class="closeBtn">
                      <a (click)="closePopup()"><img [src]="'/icons/'+baseSiteId+'/close.svg'"
                          width="20px" /></a>
                    </div>
                  </div>

                  <div class="picsum-img-wrapper">
                    <cx-media class="cx-product-image carousel-pdp" [container]="carousel?.product" format="product"
                      [alt]="img">
                    </cx-media>
                    <div class="xzoom-thumbs">
                      <a class="item">
                        <cx-media class="cx-product-image carousel-zoom" [container]="carousel?.product"
                          format="product" [alt]="img">
                        </cx-media>
                      </a>
                    </div>
                  </div>
                </ng-template>
              </ngb-carousel>
            </ng-template>
            <aside aria-label="Product Details Pdf " class="ml-2 resources-section" *ngIf="monograph.length>0"
              [ngClass]="{
                'mt-5':
                selectedProduct?.product?.images != undefined ||
                selectedProduct?.product?.images?.length > 0
              }">
              <section>
                <p class="pdfs-title">
                  {{ "plp.resources" | cxTranslate }}
                </p>
                <section class="prod-detail-pdfs" *ngFor="let doc of monograph">
                  <p class="pdfs-list">
                    <img class="pdf-icon" [src]="'/icons/'+baseSiteId+'/pdf.svg'" alt=" " />
                    <a alt=" " [href]="doc.url" target=" _blank " class="file-link blue">{{ doc?.name }}</a>
                  </p>
                </section>
              </section>
            </aside>
          </aside>
          <section class="col-xs-12 col-sm-8 col-md-8 left-section pb-2 float-left">
            <h3 class="pdp-title" [innerHTML]="selectedProduct?.product?.baseProductName"></h3>
            <p class="desc-class" [innerHTML]="selectedProduct?.product?.baseProductDescription"></p>
            <p class="variant-desc" [innerHTML]="selectedProduct?.product?.variantOptions[0].description"></p>
            <br>
            <div class="d-flex product-det">
              <div class="prod-code mr-1">{{vselectedProduct?.product?.code}}</div>
              <div>|</div>
              <div class="ml-1">{{selectedProduct?.product?.manufacturer}}</div>
            </div>
            <hr class="line">
            <section class="row">
              <div class="col-md-4 bottom-spacing price-area">
                <b>Your Price</b>
                <div class="number">
                  <span>{{selectedProduct.totalPrice?(selectedProduct?.totalPrice?.value | currency):'$--'}}</span>
                </div>
              </div>
              <div class="col-md-8">
                <div class="units mb-3">
                  <span class="unit-style">{{'Units'}}</span>
                  <section class="unit-area">
                    <input type="number" readonly class="prod-quantity text-center" value={{selectedProduct?.quantity}}
                      maxlength="4" />
                    <section class="dosessection" id="{{'noOfDoses'+selectedProduct?.code}}">
                      {{selectedProduct?.quantity*selectedProduct?.product?.quantityPerUnit}}
                      {{selectedProduct.product?.uom}}</section>
                  </section>
                </div>
              </div>
            </section>
            <section class=" products-accordion clear-fix pt2 ">
              <section class="panel-group ">
                <p class="allcll collapsed"><a>+/- All</a></p>
                <hr class="line">
                <section class="panel panel-default" *ngIf="selectedProduct?.product?.storageDescription">
                  <section class="panel-heading ">
                    <section class="first-level-acc ">
                      <label><img [src]="'/icons/'+baseSiteId+'/storage.png'" class="accordion-img "
                          alt=" "> Storage & Handling
                      </label> <span data-toggle="collapse " data-parent="#accordion " href="#pdp-list3 "
                        class="acc-plus-icon fa " aria-expanded="panelProductExpanded "
                        (click)="panelProductExpanded=! panelProductExpanded "
                        [ngClass]="panelProductExpanded? 'fa-minus': 'fa-plus collapsed' "></span>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
    </div>
  </div>
</ng-template>
